module.exports = __webpack_public_path__ + "static/media/open_video_icon.75c3f193.svg";